export const changeColumnsDealingAgent = (
  avaliation,
  service,
  attendance,
  response,
  profile,
  note,
  attendant,
  group,
  attendantQuality,
  contact,
  channel,
  status
) => ({
  type: "CHANGE_COLUMNS_DEALING_QUALITY_AGENT",
  avaliation,
  service,
  attendance,
  response,
  profile,
  note,
  attendant,
  group,
  attendantQuality,
  contact,
  channel,
  status,
});
